import React, { useCallback } from "react";

import { Button } from "antd";
import styled from "styled-components";
import { SwapOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import routes from "constants/routes";
import { useSelector } from "react-redux";
import CopyableText from "components/CopyableText";


const SiteSelectorContainer = styled.section`
  display: flex;
  align-items: center;
`;
const SiteInfo = styled.div`
  margin-left: 16px;
  .site-name {
    font-size: 16px;
    line-height: 1.2;
  }
`;
const ToggleButton = styled(Button)`
  margin-left: 12px;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
`;

const SiteSelector: React.FC = () => {
  const history = useHistory();
  const handleToggleSite = useCallback(() => {
    history.replace(routes.ENROLLMENT);
  }, [history]);
  const name = useSelector((state: any) => state?.site?.siteInfo?.name);
  const id = useSelector((state: any) => state?.site?.siteInfo?.id);
  return (
    <SiteSelectorContainer>
      <SiteInfo>
        <div className="site-name">{name}</div>
        <CopyableText color="rgba(0, 0, 0, 0.45)" size={12}>{id}</CopyableText>
      </SiteInfo>
      <ToggleButton
        onClick={handleToggleSite}
        type="dashed"
        icon={<SwapOutlined />}
        size="small"
      >
        切换
      </ToggleButton>
    </SiteSelectorContainer>
  );
};

export default SiteSelector;
